import {
  CurriculumStatus, ProgressWithContentType,
  ProgressWithStatusType,
  StudentProgressType,
  TopicsListTopic,
} from "./StudentBoard.type";

export const mergeWithStatus = ({
 studentProgress,
 curriculumStatus,
}: {
  studentProgress: StudentProgressType,
  curriculumStatus: CurriculumStatus
}): ProgressWithStatusType => {
  return {
    ...studentProgress,
    topics: studentProgress?.topics?.map(spTopic => {
      const csTopic = curriculumStatus?.topics?.find(csT => csT.id.toString() === spTopic.id.toString());
      return {
        ...spTopic,
        active: csTopic?.active ?? false,
        order: csTopic?.order ?? 0,
        circles: spTopic.circles.map(spCircle => {
          const csCircle = csTopic?.circles.find(csC => csC.id.toString() === spCircle.id.toString());
          return {
            ...spCircle,
            active: csCircle?.active ?? false,
            order: csCircle?.order ?? 0,
            activities: spCircle.activities.map(spActivity => {
              const csActivity = csCircle?.activities.find(csA => csA.id.toString() === spActivity.id.toString());
              return {
                ...spActivity,
                active: csActivity?.active ?? false,
                order: csActivity?.order ?? 0,
              };
            }),
          };
        }),
      };
    })
  }
}


export const mergeWithTopics = ({
  studentProgress,
  topicsList
}: {
  studentProgress: ProgressWithStatusType,
  topicsList: TopicsListTopic[],
}): ProgressWithContentType => {
  return {
    ...studentProgress,
    // @ts-ignore
    topics: studentProgress?.topics?.map(spTopic => {
      const topicInfo = topicsList?.find(t => t._id.toString() === spTopic.id.toString());

      return {
        ...spTopic,
        name: topicInfo?.name ?? "",
        type: topicInfo?.type ?? "",
        image_path: topicInfo?.image_path ?? "",
        redirect_link: topicInfo?.redirect_link ?? "",
        circles: spTopic.circles.map(spCircle => {
          const circleInfo = topicInfo?.circles.find(c => c.id.toString() === spCircle.id.toString());
          return {
            ...spCircle,
            lesson_type: circleInfo?.lesson_type ?? "",
          };
        })
      };
    })
  }
}
